jQuery(document).ready(function ($) {
  // primary nav
  $('.nav-primary, .middle-nav').accessibleNav({
    spans: 'show',
    level2position: 'vertical-bottom',
    level3position: 'horizontal-right'
  });

  $('.middle-nav .a1 + .toggler').on('click', function () {
    // Need to override default accessible nav open/close behavior,
    // so default everything to hide when a toggler is clicked
    $('.middle-nav .l1').removeClass('open');
    $('.middle-nav .a1 + .toggler').removeClass('open');
    $('.middle-nav .ul2').removeClass('open').hide();

    // Set a data flag on the toggler that is outside of the
    // accessible nav scope to keep track of state
    if ($(this).data('open-flag')) {
      // If flag says it's open, close it
      $(this).data('open-flag', false);
      $(this).parents('.li1').removeClass('open');
      $(this).removeClass('open');
      $(this).next('ul').removeClass('open').hide();
    } else {
      // If flag says it's closed, open it
      $(this).data('open-flag', true);
      $(this).parents('.li1').addClass('open');
      $(this).addClass('open');
      $(this).next('ul').addClass('open').show();

      // The other elements will be closed when another
      // is open so reset the flags on those to closed
      $('.middle-nav .li1').not($(this).parents('.li1')).removeClass('open');
      $('.middle-nav .a1 + .toggler').not(this).data('open-flag', false).removeClass('open');
      $('.middle-nav .ul2').not($(this).next('ul')).removeClass('open');
    }
  });

  $('.contact-us-toggle').on('click', function () {
    $('.contact-information').toggle();
  });

  //Nav Functionality - Start
  $('.nav-primary .nav-toggle').click(function () {
    $('.nav-primary .ul1').toggle();
    $('.nav-toggle .fa-bars').toggle();
    $('.nav-toggle .fa-times').toggle();
    $('header').toggleClass('fixed');
    $('body').toggleClass('fixed');
  });

  $('body').on('click', function (e) {
    var container = $('.nav-primary');
    var navToggle = $('.nav-toggle');

    if (!container.is(e.target) && container.has(e.target).length === 0 && !navToggle.is(e.target) && navToggle.has(e.target).length === 0) {
      $('.nav-toggle .fa-bars').show();
      $('.nav-toggle .fa-times').hide();
      $('header').removeClass('fixed');
      $('body').removeClass('fixed');
    }
  });

  $('.nav-primary .nav-toggle').on('keypress', function (e) {
    if (e.which === 13) {
      $('.nav-primary .ul1').toggle();
      $('.nav-toggle .fa-bars').toggle();
      $('.nav-toggle .fa-times').toggle();
      $('header').toggleClass('fixed');
      $('body').toggleClass('fixed');
    }
  });

  $('.nav-primary .li1 > .toggler').on('click', function () {
    console.log($(this));
    $('.nav-primary .toggler').not($(this)).removeClass('open');
    $('.nav-primary .ul2').not($(this).siblings('.ul2')).removeClass('open').hide();
  });

  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 0) {
      $('body').addClass('stuck-nav');
    } else if ($(this).scrollTop() == 0) {
      $('body').removeClass('stuck-nav');
    }
  });

  //I Want To menu
  $('.i-want-to > .a1.placeholder').click(function () {
    $(this).toggleClass('active');
    $('.i-want-to').toggleClass('active');
    $(document).keyup(function (e) {
      if (e.key === "Escape") {
        $('.i-want-to .a1.placeholder.active').removeClass('active');
        $('.i-want-to.active').removeClass('active');
      }
    });
    //Click outside of open middle - nav item
    $(document).on('click', function (event) {
      if (!$(event.target).closest(".i-want-to").length) {
        $('.i-want-to .a1.placeholder.active').removeClass('active');
        $('.i-want-to.active').removeClass('active');
      }
    });
  });

  $('.i-want-to > .a1.placeholder').on('keypress', function (e) {
    if (e.which === 13) {
      $(this).closest('li').toggleClass('active');
      $(this).toggleClass('active');
      $('.i-want-to ul li a:last').on('focusout', function () {
        $('.i-want-to .a1.placeholder.active').removeClass('active');
        $('.i-want-to.active').removeClass('active');
      });
    }
    $(document).keyup(function (e) {
      if (e.key === "Escape") {
        $('.i-want-to .a1.placeholder.active').removeClass('active');
        $('.i-want-to.active').removeClass('active');
      }
    });
  });

  //Search Functionality - Start
  $('.search-toggle').click(function () {
    $('.search-box').toggleClass('active');
    $('.search-toggle .fa-search').toggleClass('active');
    $('.search-toggle .fa-times').toggleClass('active');
  });

  $('.search-toggle').on('keypress', function (e) {
    if (e.which === 13) {
      $('.search-box').toggleClass('active');
      $('.search-toggle .fa-search').toggleClass('active');
      $('.search-toggle .fa-times').toggleClass('active');
    }
  });
  //Search Functionality - END

  //Scroll to Top
  $(window).scroll(function () {
    if ($(this).scrollTop() > 250) {
      $(".scroll-to-top").show();
    } else {
      $(".scroll-to-top").hide();
    }
  });
  $(".scroll-to-top").click(function () {
    $('html, body').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });

  $('#main').responsivevideos();

  //Font Resize
  var $affectedElements = $("div, p, h1, h2, h3, h4, h5, h6, ul, ol"); // Can be extended, ex. $("div, p, span.someClass")

  // Storing the original size in a data attribute so size can be reset
  $affectedElements.each(function () {
    var $this = $(this);
    $this.data("orig-size", $this.css("font-size"));
  });

  $(".font-size-increase").click(function () {
    changeFontSize(1);
    $('.font-size-normal').addClass('active');
  });

  $(".font-size-increase").on('keypress', function (e) {
    if (e.which === 13) {
      changeFontSize(1);
      $('.font-size-normal').addClass('active');
    }
  });

  $(".font-size-decrease").click(function () {
    changeFontSize(-1);
    $('.font-size-normal').addClass('active');
  });

  $(".font-size-decrease").on('keypress', function (e) {
    if (e.which === 13) {
      changeFontSize(-1);
      $('.font-size-normal').addClass('active');
    }
  });

  $(".font-size-normal").click(function () {
    $('.font-size-normal').removeClass('active');
    $affectedElements.each(function () {
      var $this = $(this);
      $this.css("font-size", $this.data("orig-size"));
    });
  });

  $(".font-size-normal").on('keypress', function (e) {
    if (e.which === 13) {
      $('.font-size-normal').removeClass('active');
      $affectedElements.each(function () {
        var $this = $(this);
        $this.css("font-size", $this.data("orig-size"));
      });
    }
  });

  function changeFontSize(direction) {
    $affectedElements.each(function () {
      var $this = $(this);
      $this.css("font-size", parseInt($this.css("font-size")) + direction);
    });
  }

  doBoardMeetings(1);
  doBoardMeetings(0);

  function doBoardMeetings(index) {
    var upcomingEventsDiv = document.getElementsByClassName('upcoming-events')[index];
    //console.log(upcomingEventsDiv.innerHTML);
    if (upcomingEventsDiv) {
      var aDates = upcomingEventsDiv.getElementsByClassName('date');
      //console.log('aDates.length: ' + aDates.length);
      if (aDates && aDates.length > 0) {
        //pf
        var a = aDates[0];
        var evDate = a.dataset.date;
        var pacificTimeOffset = (a.dataset.offset) * 60;
        var localOffset = new Date().getTimezoneOffset();
        var tzDifference = pacificTimeOffset + localOffset;
        var startDate = new Date(a.dataset.date + ' ' + a.dataset.starttime);
        var countDownDate = new Date(startDate.getTime() - tzDifference * 60 * 1000);
        var endDate = new Date(a.dataset.date + ' ' + a.dataset.endtime);
        var countDownEndDate = new Date(endDate.getTime() - tzDifference * 60 * 1000);
        var aTextInProgress = false;

        var xTimer = setInterval(function () {
          var now = Date.now();
          var distance = "";
          var distanceToEnd = "";

          distance = countDownDate - now;
          distanceToEnd = countDownEndDate - now;

          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          var minutesToEnd = Math.floor((distanceToEnd % (1000 * 60 * 60)) / (1000 * 60));
          // console.log(days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's ');
          // console.log('minutes to end: ' + minutesToEnd);
          if (days <= 0 && hours <= 0 && minutes <= 30 && seconds >= 0) {
            //console.log('Starting soon!');
            a.innerText = "Starting In " + minutes + ":" + seconds.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
            $('.date-output').hide();
          } else if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0 && minutesToEnd >= 0) {
            //console.log('in Progress');
            if (!a.classList.contains('now')) {
              a.classList.add('now');
              if (!aTextInProgress) {
                a.innerText = 'IN PROGRESS';
                aTextInProgress = true;
              }
            }
          } else if (days <= 0 && hours <= 0 && minutes <= 0 && minutesToEnd <= 0) {
            aTextInProgress = false;
            a.innerText = 'FINISHED';
            clearInterval(xTimer);
          } else {
            $('.time-output').hide();
            //console.log("Starting In " + minutes + ":" + seconds.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }));
            // a.innerText = evDate;
          }
        }, 1000);
      }
      if (aDates.length > 1) {
        var fa = aDates[1];
        var fa_evDate = fa.dataset.date;
        var fa_pacificTimeOffset = (fa.dataset.offset) * 60;
        var fa_localOffset = new Date().getTimezoneOffset();
        var fa_tzDifference = fa_pacificTimeOffset + fa_localOffset;
        var fa_startDate = new Date(fa.dataset.date + ' ' + fa.dataset.starttime);
        var fa_countDownDate = new Date(fa_startDate.getTime() - fa_tzDifference * 60 * 1000);
        var fa_endDate = new Date(fa.dataset.date + ' ' + fa.dataset.endtime);
        var fa_countDownEndDate = new Date(fa_endDate.getTime() - fa_tzDifference * 60 * 1000);
        var fa_aTextInProgress = false;

        var fxTimer = setInterval(function () {
          var now = Date.now();
          var distance = "";
          var distanceToEnd = "";

          distance = fa_countDownDate - now;
          distanceToEnd = fa_countDownEndDate - now;

          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          var minutesToEnd = Math.floor((distanceToEnd % (1000 * 60 * 60)) / (1000 * 60));
          // console.log(days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's ');
          // console.log('minutes to end: ' + minutesToEnd);
          if (days <= 0 && hours <= 0 && minutes <= 30 && seconds >= 0) {
            //console.log('Starting soon!');
            fa.innerText = "Starting In " + minutes + ":" + seconds.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
          } else if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0 && minutesToEnd >= 0) {
            //console.log('FA in Progress');
            if (!fa.classList.contains('now')) {
              fa.classList.add('now');
              if (!fa_aTextInProgress) {
                fa.innerText = 'IN PROGRESS';
                fa_aTextInProgress = true;
              }
            }
          } else if (days <= 0 && hours <= 0 && minutes <= 0 && minutesToEnd <= 0) {
            fa_aTextInProgress = false;
            fa.innerText = 'FINISHED';
            clearInterval(fxTimer);
          } else {
            //console.log("Starting In " + minutes + ":" + seconds.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }));
            // fa.innerText = evDate;
          }
        }, 1000);
      }
    }
  }

  $('.mega-footer-menu .menu-title').on('click', function () {
    $(this).toggleClass('open');
  });



  // Handle deep link to tabs by tab ID
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };

  var tabID = '#' + getUrlParameter('tab');
  var container = '#tabContainer' + getUrlParameter('tc');

  if (getUrlParameter('tab')) {
    if (getUrlParameter('tc')) {
      $(container).find('section').attr('aria-hidden', null);
      $(container).find('a').attr('aria-selected', null);
      switchTabs(tabID, container);
      $('html, body').animate({ scrollTop: $(container).offset().top - 350 });
    } else {
      $(tabContainer).find('section').attr('aria-hidden', null);
      $(tabContainer).find('a').attr('aria-selected', null);
      switchTabs(tabID, tabContainer);
      $('html, body').animate({ scrollTop: $(tabID).offset().top - 350 });
    }
  }

  function switchTabs(tabID, tabContainer) {
    // Hide panels
    $('[role="tabpanel"]', tabContainer).attr('aria-hidden', 'true');
    // show corresponding panel
    $(tabContainer).find('.tabs a').attr('aria-selected', null);
    $(tabContainer).find('section' + tabID).attr('aria-hidden', null);
    $(tabContainer).find('a[href=' + tabID + ']').attr('aria-selected', 'true');
  }
});

$(".button.hide").remove();
